module.exports = __webpack_public_path__ + "static/img/work-idea-img1.395b6c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/introduce/work-idea-img1.jpg
// module id = L8aQ
// module chunks = 1